import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    dates:[],
    datesMobile:[],
    selectedDate: new Date(),
}

const dateReducer = createSlice({
    name: 'business',
    initialState,
    reducers:{
        setDate: (state,action)=>{
            state.dates = action.payload;
        },
        setMobileDate: (state,action)=>{
            state.datesMobile = action.payload;
        },
        setSelectedDate: (state,action)=>{
            state.selectedDate = action.payload;
        },
    }
});

export default dateReducer.reducer;

export const {setDate,setMobileDate,setSelectedDate} = dateReducer.actions; 